import { render, staticRenderFns } from "./leader-page.vue?vue&type=template&id=2f7485d1&scoped=true"
import script from "./leader-page.vue?vue&type=script&lang=js"
export * from "./leader-page.vue?vue&type=script&lang=js"
import style0 from "./leader-page.vue?vue&type=style&index=0&id=2f7485d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7485d1",
  null
  
)

export default component.exports